module.exports = "/images/avatar-s-17.jpg?2a01b3070e0d050d230008a2650ec91a";